import { Box, Stack, Typography, useTheme } from '@mui/material';
import CopyButton from '../../commonUI/CopyButton';

type DebugInfoSimpleInfoItemProps = {
  label: string;
  value?: string;
  showCopyButton?: boolean;
  labelFontWeight?: string | number;
};

/**
 * A simple section component that displays a label-value pair in a box
 * styled to match DebugInfoSection but for simpler content
 */
export const DebugInfoSimpleInfoItem = ({
  label,
  value = '',
  showCopyButton = true,
  labelFontWeight = 'medium',
}: DebugInfoSimpleInfoItemProps) => {
  const theme = useTheme();

  return (
    <Box
      width={'100%'}
      sx={{
        backgroundColor: theme.vars.palette.background.default,
        borderRadius: 1,
        p: 3,
        mb: 3,
        boxShadow: 1,
        border: `1px solid ${theme.vars.palette.divider}`,
      }}
    >
      <Stack direction='row' spacing={1} alignItems='center'>
        <Typography
          variant='body1'
          sx={{
            color: theme.vars.palette.text.primary,
            fontWeight: labelFontWeight,
          }}
        >
          {`${label}:`}
        </Typography>

        <Typography
          variant='body1'
          sx={{ color: theme.vars.palette.text.secondary }}
        >
          {value}
        </Typography>

        {value && showCopyButton && <CopyButton textToCopy={value} />}
      </Stack>
    </Box>
  );
};
